export { default } from "./AspectRatio";
export type { AspectRatios } from "./AspectRatio";
